function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.203 78.7119L60.8452 32.9916L60.8411 24.8298L16.653 74.5423H6.50159L66.3188 6.64233L66.3229 25.5325V128.325L20.203 78.7119Z",
  fill: "#C58FFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M66.1153 7.18209V24.5202V127.807L20.4758 78.718L60.945 33.1831L61.0488 33.069V32.9122V25.3655V24.2941L60.3384 25.0946L16.5614 74.3468H6.9515L66.1153 7.18209ZM66.5224 6.10254L6.04974 74.7542H16.7446L60.6376 25.3655V32.9142L19.9283 78.7159L66.5265 128.844V25.5325V6.10254H66.5224Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.49756 82.5208H16.655L66.325 136.374V150.447L6.49756 82.5208Z",
  fill: "#C58FFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5655 82.7245L66.1214 136.454V149.916L6.94943 82.7245H16.5655ZM16.7446 82.3171H6.04767L66.5285 150.987V136.295L16.7446 82.3171Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M0.453918 82.5208H5.95606L66.3229 151.064L66.3005 156.466L0.453918 82.5208Z",
  fill: "#A9FF03"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.86244 82.7245L66.1194 151.138L66.1011 155.933L0.907864 82.7245H5.86244ZM6.04768 82.3171H0L66.5021 157L66.5285 150.987L6.04768 82.3171Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0.453918 74.5423L66.3005 0.619202L66.3229 6.02309L5.9581 74.5423H0.453918Z",
  fill: "#A9FF03"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M66.1011 1.15188L66.1194 5.94674L5.86651 74.3478H0.907864L66.1011 1.15188ZM66.5082 0.088623L0 74.7552H6.04971L66.5285 6.11173L66.5021 0.088623H66.5082Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M127.048 74.5423L74.2209 5.98846V0.586609L132.575 74.5423H127.048Z",
  fill: "#A9FF03"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M74.4244 1.17325L132.155 74.3468H127.148L74.4265 5.92737V1.17325H74.4244ZM74.0194 0V6.05773L126.948 74.7542H132.994L74.0173 0H74.0194Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M74.2209 150.942L127.052 82.5208H132.579L74.2209 156.344V150.942Z",
  fill: "#A9FF03"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M132.159 82.7245L74.4245 155.76V151.012L127.146 82.7245H132.153H132.159ZM132.994 82.3171H126.952L74.0275 150.873V156.931L133 82.3171H132.994Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M113.654 74.5423L74.335 25.174L74.225 6.66064L126.535 74.5423H113.654Z",
  fill: "#C58FFF"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M74.4326 7.26358L126.12 74.3468H113.752L74.5384 25.1027L74.4326 7.26358ZM74.0255 6.05774L74.1395 25.2474L113.556 74.7542H126.948L74.0234 6.06589L74.0255 6.05774Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M74.2229 135.509H74.2189L74.2087 82.5208H126.539L74.2209 150.276L74.2229 135.509Z",
  fill: "#C58FFF"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M126.124 82.7245L74.4204 149.679V135.712V135.305L74.4102 82.7245H126.114H126.124ZM126.942 82.3171H74.0051L74.0153 135.712V150.873L126.94 82.3171H126.942Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M74.2087 74.5423L74.2148 33.5151L105.561 74.5423H74.2087Z",
  fill: "#C58FFF"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M74.4184 34.116L105.147 74.3467H74.4102V34.1241L74.4184 34.116ZM74.0031 32.9224V74.7541H105.962L74.0031 32.9224Z",
  fill: "black"
});

function SvgCopypageLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 157,
    viewBox: "0 0 133 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopypageLogo);
export default __webpack_public_path__ + "static/media/copypage-logo.91546664.svg";
export { ForwardRef as ReactComponent };